module.exports = __webpack_public_path__ + "img/20220726210057428utc.a1abc2a3.jpg";